import { render, staticRenderFns } from "./otodetflzs.vue?vue&type=template&id=40ff702d&scoped=true&"
import script from "./otodetflzs.vue?vue&type=script&lang=js&"
export * from "./otodetflzs.vue?vue&type=script&lang=js&"
import style0 from "./otodetflzs.vue?vue&type=style&index=0&id=40ff702d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ff702d",
  null
  
)

export default component.exports